// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f1fbbd62","223":"9ab220ba","239":"41cece02","455":"f81859e3"}[chunkId] + ".chunk.js";
};